import { render } from "./settledgames.vue?vue&type=template&id=7289a633"
import script from "./settledgames.vue?vue&type=script&lang=js"
export * from "./settledgames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__